var i=(t,e)=>{if(!t)return "0xUNKNOWN";let n="...",r=e?.start??6,s=e?.end??4,[,o,c]=new RegExp(`^(.{${r}}).+(.{${s}})$`).exec(t)??[];return [o,c].filter(Boolean).join(n)||t},p="0x0000000000000000000000000000000000000000";

export { p as NIL_ADDRESS, i as truncateAddress };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map